export const themes = {
  dark: {
    name: 'dark',
    colors: {
      appBg: 'radial-gradient(circle at top, #0f172a, #020617)',
      surface: 'rgba(15, 23, 42, 0.72)',
      surfaceStrong: 'rgba(15, 23, 42, 0.9)',
      border: 'rgba(255,255,255,0.08)',
      borderSoft: 'rgba(255,255,255,0.05)',

      textPrimary: '#e5e7eb',
      textSecondary: '#cbd5e1',
      textMuted: '#94a3b8',

      primary: '#6366f1',
      primaryStrong: '#8b5cf6',
      primaryGradient: 'linear-gradient(135deg, #6366f1, #8b5cf6)',

      headerBg: 'rgba(2, 6, 23, 0.45)',
      headerText: '#e5e7eb',

      success: '#22c55e',
      danger: '#ef4444',

      inputBg: 'rgba(255,255,255,0.05)',
      inputBorder: 'rgba(255,255,255,0.14)',

      tableBorder: 'rgba(255,255,255,0.08)',
      tableRowBorder: 'rgba(255,255,255,0.05)',

      errorBg: 'rgba(127, 29, 29, 0.35)',
      errorText: '#fecaca',

      popupBg: 'rgb(10, 20, 56)',
      popupText: '#e5e7eb',
      popupBorder: 'rgba(255,255,255,0.10)',
      popupItemBg: 'rgba(255,255,255,0.06)',
      popupItemBorder: 'rgba(255,255,255,0.10)',
    },
    effects: {
      blur: 'blur(12px)',
      shadow: '0 10px 40px rgba(0,0,0,0.6)',
      radiusLg: '20px',
      radiusMd: '18px',
      radiusSm: '10px',
    },
  },

  light: {
    name: 'light',
    colors: {
      appBg: 'linear-gradient(180deg, #f8fafc, #e2e8f0)',
      surface: 'rgba(255,255,255,0.9)',
      surfaceStrong: 'rgba(255,255,255,0.98)',
      border: 'rgba(15,23,42,0.08)',
      borderSoft: 'rgba(15,23,42,0.05)',

      textPrimary: '#0f172a',
      textSecondary: '#475569',
      textMuted: '#64748b',

      primary: '#4f46e5',
      primaryStrong: '#7c3aed',
      primaryGradient: 'linear-gradient(135deg, #4f46e5, #7c3aed)',

      headerBg: 'rgba(79, 70, 229, 0.97)',
      headerText: '#ffffff',

      success: '#16a34a',
      danger: '#dc2626',

      inputBg: 'rgba(255,255,255,0.95)',
      inputBorder: 'rgba(15,23,42,0.12)',

      tableBorder: 'rgba(15,23,42,0.08)',
      tableRowBorder: 'rgba(15,23,42,0.05)',

      errorBg: '#fee2e2',
      errorText: '#991b1b',

      popupBg: '#ffffff',
      popupText: '#0f172a',
      popupBorder: 'rgba(15,23,42,0.12)',
      popupItemBg: 'rgba(15,23,42,0.04)',
      popupItemBorder: 'rgba(15,23,42,0.10)',
    },
    effects: {
      blur: 'blur(8px)',
      shadow: '0 10px 30px rgba(15,23,42,0.12)',
      radiusLg: '20px',
      radiusMd: '18px',
      radiusSm: '10px',
    },
  },
};